import request from '../../utils/request';

// 获取系统菜单功能路径
export function sysRoleMenu(authorization){
  return request({
    url: '/api/role/system/sysRoleMenu',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取角色对应员工范围和menuId
export function getRoleEmpMenuId(params,authorization){
  return request({
    url: '/api/role/getRoleEmpMenuId',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 创建角色
export function createRole(params,authorization){
  return request({
    url: '/api/role/createRole',
    data:params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
// 修改角色
export function editRole(params,authorization){
  return request({
    url: '/api/role/updateRole',
    data:params,
    method: 'put',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取角色列表
export function getRole(authorization){
  return request({
    url: '/api/role/getRole',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 添加角色成员
export function createRoleEmp(params,authorization){
  return request({
    url: '/api/role/createRoleEmp',
    data: params,
    method: 'post',
    headers: {
      "authorization": authorization
    }
  })
}
// 更新角色的menuId
export function updateRoleMenuId(params,authorization){
  return request({
    url: '/api/role/updateRoleMenuId',
    data: params,
    method: 'put',
    headers: {
      "authorization": authorization
    }
  })
}
// 删除角色
export function deleteRole(params,authorization){
  return request({
    url: 'api/role/deleteRole',
    data: params,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
// 删除角色成员
export function deleteRoleEmp(params,authorization){
  return request({
    url: '/api/role/deleteRoleEmp',
    data: params,
    method: 'delete',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取角色下成员
export function getRoleEmp(params,authorization){
  return request({
    url: '/api/role/getRoleEmp',
    params,
    method: 'get',
    headers: {
      "authorization": authorization
    }
  })
}
// 获取企业点位详情
export function getPointDetail(Authorization,isloading){
  return request({
    url: '/api/role/getPointDetail',
    method: 'get',
    headers: {
      "authorization": Authorization,
    }
  },isloading)
}